







import Vue from "vue";

export default Vue.extend({
  methods: {
    showDialog(id: string) {
      this.$dialog.show(id);
    }
  }
});
